import request from 'utils/request'

/**
 * 获取申请列表
 * @param {*} data
 */
export const getApplyList = data => request().post('bp/apply/pageMine', data)

/**
 * 获取申请列表
 * @param {*} data
 */
export const getExtensionList = data =>
  request().post('limit/apply/pageMine', data)

/**
 * 获取申请页详情
 * @param data
 * @returns {*}
 */

export const getApplyDetail = data => {
  return request().get(`bp/approve/detail/${data}`)
}

/**
 * 获取自动审核申请页详情
 * @param data
 * @returns {*}
 */
export const getApplyDetailByCreditBpmId = data => {
  return request().get(`bp/autoApprove/detail/${data}`)
}

/**
 * 获取单个限额延期申请页详情
 * @param data
 * @returns {*}
 */

export const getLimitDetail = data => {
  return request().get(`limit/approve/detail/${data}`)
}

/**
 * 获取申请页详情
 * @param data
 * @returns {*}
 */

export const getApplyTermDetail = data => {
  return request().get(`bp/approve/term/detail/${data}`)
}

/**
 * 获取jsonList类型的业务类型列表
 */
export const getBusinessJsonList = () => request().get('business/jsonList')

/**
 * 下载附件
 * @param {*} data assurance/download
 */
export const downloadAttachment = id => {
  return request().get(`bp/attachment/download/${id}`, {
    responseType: 'blob',
  })
}

/**
 * 附件上传文件
 * @param {*} data
 */
export const uploadFile = data => {
  return request().post('bp/attachment/upload', data)
}

/**
 * 附件删除文件
 * @param {*} id
 */
export const deleteFile = id => {
  return request().get(`bp/attachment/delete/${id}`)
}

/**
 * 下载批量文件
 * @param {*} id
 */
export const downloadBatchFile = id =>
  request().get(`bp/batch/download/${id}`, { responseType: 'blob' })

// 获取业务类型列表
export const getFreezeBgList = () =>
  request().get('business/jsonList/getFreezeBgList')

/**
 * 下载批量文件
 * @param {*} id
 */
export const downloadLimitBatchFile = id =>
  request().get(`limit/batch/download/${id}`, { responseType: 'blob' })
